export function sanitizeNumber(v: string) {
  return v.replace(/[^0-9]/g, '');
}
